import { render, staticRenderFns } from "./ReadOnlySentence.vue?vue&type=template&id=19a9a7e8&lang=pug&"
import script from "./ReadOnlySentence.vue?vue&type=script&lang=js&"
export * from "./ReadOnlySentence.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlySentence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports